import {
  CalendarDays,
  ChartColumn,
  Folder,
  Home,
  ReceiptText,
  UserCog,
  UserRound,
  type LucideIcon,
} from 'lucide-react';
import { ROUTES } from 'constants/routes';

export interface NavRoute {
  href?: string;
  label: string;
  icon: LucideIcon;
}

export const HOME_NAV_ROUTE: NavRoute = {
  href: ROUTES.HOME,
  label: 'start',
  icon: Home,
};

export const COMMON_NAV_ROUTES: NavRoute[] = [
  { href: ROUTES.HOME, label: 'start', icon: Home },

  { href: ROUTES.BILLING, label: 'insuranceBilling', icon: ReceiptText },
  { href: ROUTES.DOCS, label: 'insuranceDocuments', icon: Folder },
];

export const MANAGER_NAV_ROUTES: NavRoute[] = [
  { href: ROUTES.PATIENTS, label: 'insurancePatients', icon: UserRound },
  {
    href: ROUTES.APPOINTMENTS,
    label: 'insuranceAppointments',
    icon: CalendarDays,
  },
];

export const BILLING_NAV_ROUTES: NavRoute[] = [
  { href: ROUTES.BILLING, label: 'insuranceBilling', icon: ReceiptText },
  { href: ROUTES.DOCS, label: 'insuranceDocuments', icon: Folder },
];

export const ADMIN_NAV_ROUTES: NavRoute[] = [
  HOME_NAV_ROUTE,
  ...MANAGER_NAV_ROUTES,
  ...BILLING_NAV_ROUTES,
  {
    href: ROUTES.METRICS,
    label: 'insuranceMetrics',
    icon: ChartColumn,
  },
  {
    href: ROUTES.ADMINISTRATORS,
    label: 'insuranceAdministrators',
    icon: UserCog,
  },
];
